"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnGroupPicker = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var ColDefGrouping_1 = require("./ColDefGrouping");
var Accordion_1 = require("../../Components/Accordion");
exports.ColumnGroupPicker = function (_a) {
    var group = _a.group, selectedColumnIds = _a.selectedColumnIds, setSelectedColumnIds = _a.setSelectedColumnIds, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.searchValue, searchValue = _c === void 0 ? '' : _c, onAccordionClick = _a.onAccordionClick, _d = _a.hideSelectAll, hideSelectAll = _d === void 0 ? false : _d;
    var _e = react_1.useState(isOpen), isAccordionOpen = _e[0], setIsAccordionOpen = _e[1];
    var toggleSelectedColumn = function (checkedColId) {
        var newSet = new Set(selectedColumnIds);
        if (selectedColumnIds.has(checkedColId)) {
            newSet.delete(checkedColId);
        }
        else {
            newSet.add(checkedColId);
        }
        setSelectedColumnIds(newSet);
    };
    var onSelectAllSelected = function (checkedColId, enabled) {
        var newSet = new Set(selectedColumnIds);
        if (enabled) {
            checkedColId.forEach(function (colId) { return newSet.add(colId); });
        }
        else {
            checkedColId.forEach(function (colId) { return newSet.delete(colId); });
        }
        setSelectedColumnIds(newSet);
    };
    return (react_1.default.createElement(Accordion_1.Accordion, { label: group.name, count: selectedColumnIds.size, isOpen: isOpen, onClick: onAccordionClick !== null && onAccordionClick !== void 0 ? onAccordionClick : (function () { return setIsAccordionOpen(!isAccordionOpen); }), defaultIsOpen: isOpen },
        react_1.default.createElement(ColDefGrouping_1.ColDefGrouping, { searchValue: searchValue, key: group.name, group: group, selectedColIds: selectedColumnIds, onCheckboxSelected: toggleSelectedColumn, onSelectAllSelected: onSelectAllSelected, hideSelectAll: hideSelectAll })));
};
